export default {
  data_source: 'data_source',
  data_derived: 'data_derived',
  splitter_output: 'splitter_output',
  splitter: 'splitter',
  api_endpoint: 'api_endpoint',
  api_result: 'api_result',
  api_error: 'api_error',
  api_modifier: 'api_modifier',
  rag_retriever: 'rag_retriever',
  rag_reranker: 'rag_reranker',
  rag_enricher: 'rag_enricher',
  rag_query_rewriter: 'rag_query_rewriter',
} as const;
